// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__Sr4WP","expanded":"style_expanded__JJnhy"};